document.addEventListener("DOMContentLoaded", () => {
  const should_animate_parallax = (element) => {
    if(!element.offsetParent) return false;

    const viewport = {
      top: window.scrollY,
      bottom: window.scrollY + window.innerHeight,
    };

    const bounds = {
      top: window.scrollY + (element.offsetTop + element.offsetParent.offsetTop - window.scrollY),
    };
    bounds.bottom = bounds.top + element.offsetHeight;

    if(!(viewport.bottom < bounds.top || viewport.top > bounds.bottom)){
      return true;
    }else{
      return false;
    }
  }

  const element_parallax_progress = (element) => {
    const rect = element.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    let progress = null;

    if (rect.top >= viewportHeight) {
      progress = 1;
    } else if (rect.bottom <= 0) {
      progress = -1;
    } else {
      progress = -1 + 2 * (rect.bottom / (viewportHeight + rect.height));
    }

    return progress;
  }

  document.querySelectorAll(".scrolling-images-item").forEach((section) => {
    const content = section.querySelector(".scrolling-images-item-inner");

    if (!content) return;

    function checkPosition() {
      const sectionRect = section.getBoundingClientRect();
      const contentRect = content.getBoundingClientRect();
      const parentRect = section.closest('.scrolling-images').getBoundingClientRect();
      const viewportMiddle = window.innerHeight / 2;
      const contentStyle = window.getComputedStyle(content);
      const inMiddle = sectionRect.top <= viewportMiddle && sectionRect.bottom > viewportMiddle;
      const inParent = sectionRect.top <= parentRect.top && sectionRect.bottom > parentRect.bottom;
      const aboveParent = (contentRect.top + parseInt(contentStyle.paddingTop, 10)) < parentRect.top;
      const belowParent = (contentRect.bottom - parseInt(contentStyle.paddingBottom, 10)) > parentRect.bottom;

      if ((inMiddle || inParent) && !aboveParent && !belowParent) {
        content.classList.add("in-position");
      } else {
        content.classList.remove("in-position");
      }
    }

    window.addEventListener("scroll", checkPosition, { passive: true });
    window.addEventListener("resize", checkPosition);
    checkPosition();

    section.querySelectorAll('.scrolling-images-item-image').forEach((image) => {
      const run_image_parallax = () => {
        if(!window.matchMedia('(prefers-reduced-motion: reduce)').matches){ 
          if(true || should_animate_parallax(image)){
            let progress = element_parallax_progress(image);
            let roundedProgress = (progress).toFixed(4);
            image.style.setProperty('--progress', roundedProgress);
          }
        }
      }

      window.addEventListener('scroll', function(){
        window.requestAnimationFrame(run_image_parallax);
      });
      window.addEventListener('resize', function(){
        window.requestAnimationFrame(run_image_parallax);
      });

      window.requestAnimationFrame(run_image_parallax);
    });
  });
});